import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './Banners.css';
import bannerSketch from '../Assets/banner_sketch.png';
import bannerGuluEffect from '../Assets/banner_gulueffect.jpg';

const Banners = () => {
    const navigate = useNavigate();
    const bannersRef = useRef(null);
    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 480);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleMouseDown = (e) => {
        setIsDown(true);
        setStartX(e.pageX - bannersRef.current.offsetLeft);
        setScrollLeft(bannersRef.current.scrollLeft);
    };

    const handleMouseLeave = () => {
        setIsDown(false);
    };

    const handleMouseUp = () => {
        setIsDown(false);
    };

    const handleMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - bannersRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll-fast
        bannersRef.current.scrollLeft = scrollLeft - walk;
    };

    const scrollLeftFunc = () => {
        bannersRef.current.scrollLeft -= bannersRef.current.clientWidth;
    };

    const scrollRightFunc = () => {
        bannersRef.current.scrollLeft += bannersRef.current.clientWidth;
    };

    return (
        <div className="banners-container">
            {isSmallScreen && <button className="arrow left" onClick={scrollLeftFunc}>&lt;</button>}
            <div
                className="banners"
                ref={bannersRef}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
            >
                <img
                    src={bannerSketch}
                    alt="Sketch."
                    onClick={() => navigate('/sketch')}
                    className="banner"
                />
                <img
                    src={bannerGuluEffect}
                    alt="Gulu Effect"
                    onClick={() => navigate('/gulueffect')}
                    className="banner"
                />
            </div>
            {isSmallScreen && <button className="arrow right" onClick={scrollRightFunc}>&gt;</button>}
        </div>
    );
}

export default Banners;
